<div class="container-fluid access-page">

    <div class="access-card">

        <!-- ====================================================== -->
        <!-- HEADER -->
        <!-- ====================================================== -->

        <div class="access-header">

            <div class="header-content">

                <div class="header-icon">
                    <i class="fa-solid fa-shield-halved"></i>
                </div>

                <div class="header-info">

                    <h5 class="header-title">
                        Gestión de Accesos
                    </h5>

                    <p class="header-description">
                        Administra los permisos y accesos disponibles para cada modelo.
                    </p>

                </div>

            </div>

        </div>


        <!-- ====================================================== -->
        <!-- BODY -->
        <!-- ====================================================== -->

        <div class="access-body">


            <!-- ================================================== -->
            <!-- SELECCIÓN DE MODELO -->
            <!-- ================================================== -->

            <section class="filter-section">

                <div class="section-header">

                    <div class="section-icon">
                        <i class="fa-solid fa-cubes"></i>
                    </div>

                    <div class="section-info">

                        <h6 class="section-title">
                            Selección de modelo
                        </h6>

                        <p class="section-description">
                            Selecciona un modelo para consultar y gestionar sus accesos.
                        </p>

                    </div>

                </div>


                <!-- SELECT -->

                <div class="model-selector">

                    <div class="field-group">

                        <label for="modelo" class="form-label">
                            Modelo
                        </label>


                        <div class="select-wrapper">

                            <i class="fa-solid fa-cube select-icon"></i>

                            <select
                                id="modelo"
                                name="modelo"
                                class="form-control model-select"
                                (change)="selectionModulo($event)">

                                <option value="">
                                    Seleccione un modelo
                                </option>

                                <option
                                    *ngFor="let list of listModulo"
                                    [value]="list.nombre_corto">

                                    {{ list.nombre }}

                                </option>

                            </select>

                            <i class="fa-solid fa-chevron-down select-arrow"></i>

                        </div>

                    </div>

                </div>

            </section>


            <!-- ================================================== -->
            <!-- TABLA -->
            <!-- ================================================== -->

            <section class="table-section">

                <div class="table-section-header">

                    <div>

                        <h6 class="table-section-title">
                            Accesos
                        </h6>

                        <p class="table-section-description">
                            Listado de accesos asociados al modelo seleccionado.
                        </p>

                    </div>

                </div>


                <div class="table-container">

                    <app-paginacion
                        [currentPage]="currentPage"
                        [totalItems]="totalItems"
                        [selectedPageSize]="pageSize"
                        [paginatedData]="currentItems"
                        [headers]="tableHeaders"
                        [actions]="customActions"
                        (pageChange)="onPageChange($event)"
                        (pageSizeChange)="onPageSizeChange($event)"
                        [loading]="spinner">
                    </app-paginacion>

                </div>

            </section>

        </div>

    </div>

</div>


<!-- ============================================================ -->
<!-- MODAL GESTIÓN DE ACCESOS -->
<!-- ============================================================ -->

<ng-template #modalAgregarParametro let-modal>

    <!-- HEADER -->

    <div class="access-modal-header">

        <div class="modal-title-wrapper">

            <div class="modal-title-icon">
                <i class="fa-solid fa-shield-halved"></i>
            </div>

            <div class="modal-title-info">

                <h5 class="modal-title">
                    Gestión de Accesos
                </h5>

                <p>
                    Configura la información correspondiente al acceso.
                </p>

            </div>

        </div>


        <button
            type="button"
            class="btn-close"
            aria-label="Cerrar"
            (click)="modal.dismiss('Cross click')">
        </button>

    </div>


    <!-- BODY -->

    <div class="access-modal-body">

        <form
            [formGroup]="formParametros"
            class="access-form">


            <!-- ================================================== -->
            <!-- PARÁMETRO -->
            <!-- ================================================== -->

            <div class="field-group">

                <label class="form-label">
                    Parámetro
                </label>

                <div class="input-wrapper">

                    <i class="fa-solid fa-code input-icon"></i>

                    <input
                        type="text"
                        class="form-control"
                        placeholder="Ej. timeout_session"
                        formControlName="parametro" />

                </div>

            </div>


            <!-- ================================================== -->
            <!-- ETIQUETA -->
            <!-- ================================================== -->

            <div class="field-group">

                <label class="form-label">
                    Etiqueta
                </label>

                <div class="input-wrapper">

                    <i class="fa-solid fa-tag input-icon"></i>

                    <input
                        type="text"
                        class="form-control"
                        placeholder="Ej. Tiempo de sesión"
                        formControlName="etiqueta" />

                </div>

            </div>


            <!-- ================================================== -->
            <!-- VALOR -->
            <!-- ================================================== -->

            <div class="field-group">

                <label class="form-label">
                    Valor del parámetro
                </label>

                <div class="input-wrapper">

                    <i class="fa-solid fa-sliders input-icon"></i>

                    <input
                        type="text"
                        class="form-control"
                        placeholder="Ej. 30"
                        formControlName="valorParametro" />

                </div>

            </div>


            <!-- ================================================== -->
            <!-- DESCRIPCIÓN -->
            <!-- ================================================== -->

            <div class="field-group mb-0">

                <label class="form-label">
                    Descripción
                </label>

                <textarea
                    class="form-control description-field"
                    rows="4"
                    placeholder="Describe para qué sirve este parámetro"
                    formControlName="descripcion">
                </textarea>

            </div>

        </form>

    </div>

</ng-template>